import React, { useState } from 'react';
import { useInView } from 'react-intersection-observer';
import { FaChevronDown, FaChevronRight, FaExternalLinkAlt } from 'react-icons/fa';
import './Teaching.css';

const Teaching = () => {
  const [ref] = useInView({
    threshold: 0.3,
    triggerOnce: true
  });

  const [expandedSection, setExpandedSection] = useState(true);
  const [expandedOfferings, setExpandedOfferings] = useState({});

  const toggleSection = () => {
    setExpandedSection(!expandedSection);
  };

  const toggleOfferings = (courseIndex) => {
    setExpandedOfferings(prev => ({
      ...prev,
      [courseIndex]: !prev[courseIndex]
    }));
  };

  const courses = [
    {
      title: "Data Analytics",
      level: "Master",
      image: "/assets/img/970x647/7.png",
      description: "Comprehensive data analytics courses taught across multiple institutions, covering various applications in economics, finance, accounting, and performance management.",
      offerings: [
        {
          name: "Data Analytics for Economics and Finance",
          institution: "University of Groningen",
          url: "https://ocasys.rug.nl/2025-2026/catalog/course/EBB154A05"
        },
        {
          name: "Data Analytics for Performance Management",
          institution: "University of Groningen",
          url: "https://docs.google.com/document/d/e/2PACX-1vQ6xuAHQCdssQTOm65BXzVDQA2w2uOtajoyXsunr88Lb3I3lxSWGbFWqHW_TH6m7MZjzXMBy2-e8Klo/pub"
        },
        {
          name: "Data Analytics in Finance and Accounting",
          institution: "Goethe University Frankfurt",
          url: "https://qis.server.uni-frankfurt.de/qisserver/rds?state=verpublish&status=init&vmfile=no&publishid=322122&moduleCall=webInfo&publishConfFile=webInfo&publishSubDir=veranstaltung"
        }
      ],
      links: []
    },
    {
      title: "Natural Language Processing",
      level: "Master",
      image: "/assets/img/970x647/llm.png",
      description: "Advanced courses in Natural Language Processing, covering applications in finance and the latest developments in Large Language Models and AI agents.",
      offerings: [
        {
          name: "NLP in Finance",
          institution: "EDHEC Business School",
          url: "#"
        },
        {
          name: "LLM Agents Workshop",
          institution: "Workshop",
          url: "https://docs.google.com/document/d/e/2PACX-1vSdfVbj5yeKtIgZkWMg2nkA5_iPZol3Vaf8mqoRqle6e39prZrnGvUJ-JmS8YSzfa5wyOAVRAGaBQ4R/pub"
        }
      ],
      links: []
    },
    {
      title: "Mergers and Acquisitions",
      level: "Master",
      image: "/assets/img/970x647/1.png",
      description: "You can find the QIS page here. The syllabus and course materials are in OLAT.",
      links: [
        { text: "QIS page", url: "https://qis.server.uni-frankfurt.de/qisserver/rds?state=verpublish&status=init&vmfile=no&publishid=291634&moduleCall=webInfo&publishConfFile=webInfo&publishSubDir=veranstaltung" },
        { text: "OLAT", url: "https://olat-ce.server.uni-frankfurt.de/olat/auth/RepositoryEntry/8161722410" }
      ]
    },
    // {
    //   title: "Mathematics",
    //   level: "Bachelor",
    //   image: "/assets/img/970x647/6.png",
    //   description: "You can find the solutions' notebook here.",
    //   links: [
    //     { text: "Solutions notebook", url: "https://dl.sasanm.ir/math" }
    //   ]
    // },
    // {
    //   title: "Microeconomics 2",
    //   level: "Bachelor",
    //   image: "/assets/img/970x647/4.png",
    //   description: "You can find the solutions' notebook here.",
    //   links: [
    //     { text: "Solutions notebook", url: "https://goetheuniversitaet-my.sharepoint.com/:o:/g/personal/fletgjr8la_goetheuniversitaet_onmicrosoft_com/EvqnZCF11sBCpd5y_KaqN70BQhxwCxyyw9YqA4Now0CFRw" }
    //   ]
    // },
    {
      title: "Thesis Supervision",
      level: "",
      image: "/assets/img/970x647/3.png",
      description: "Please feel free to contact me to discuss possible bachelor/master thesis topics. You can find the guidelines for writing a thesis in our chair in this document.",
      links: [
        { text: "Writing Guidelines", url: "/assets/img/WritingGuidelines.pdf" }
      ]
    }
  ];

  return (
    <section id="teaching" className="teaching section" ref={ref}>
      <div className="container">
        <div className="section-title">
          <h2>Teaching</h2>
          <p>My academic courses and supervision opportunities</p>
        </div>

        <div className="teaching-content">
          <div className="teaching-section">
            <button 
              className="section-header"
              onClick={toggleSection}
            >
              {expandedSection ? <FaChevronDown /> : <FaChevronRight />}
              <h3>Courses</h3>
            </button>
            
            {expandedSection && (
              <div className="section-content">
                <div className="courses-grid">
                  {courses.map((course, index) => (
                    <div key={index} className="course-card">
                      <div className="course-image">
                        <img src={course.image} alt={course.title} />
                        <div className="course-level">
                          {course.level}
                        </div>
                      </div>
                      <div className="course-content">
                        <h4>{course.title}</h4>
                        <p>{course.description}</p>
                        
                        {course.offerings && (
                          <div className="course-offerings">
                            <button 
                              className="offerings-header"
                              onClick={() => toggleOfferings(index)}
                            >
                              {expandedOfferings[index] ? <FaChevronDown /> : <FaChevronRight />}
                              <h5>Course Offerings ({course.offerings.length})</h5>
                            </button>
                            
                            {expandedOfferings[index] && (
                              <ul>
                                {course.offerings.map((offering, offeringIndex) => (
                                  <li key={offeringIndex}>
                                    <strong>{offering.name}</strong>
                                    <br />
                                    <span className="institution">{offering.institution}</span>
                                    <a 
                                      href={offering.url} 
                                      target="_blank" 
                                      rel="noopener noreferrer"
                                      className="offering-link"
                                    >
                                      View Course <FaExternalLinkAlt />
                                    </a>
                                  </li>
                                ))}
                              </ul>
                            )}
                          </div>
                        )}
                        
                        <div className="course-links">
                          {course.links.map((link, linkIndex) => (
                            <a 
                              key={linkIndex}
                              href={link.url} 
                              target="_blank" 
                              rel="noopener noreferrer"
                              className="course-link"
                            >
                              {link.text} <FaExternalLinkAlt />
                            </a>
                          ))}
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    </section>
  );
};

export default Teaching; 